<template>
  <div>
    <h1 class="header-tittle">{{ title }}</h1>
  </div>
</template>
<script>
export default {
  name: "header-title",
  props: ["title"]
};
</script>
<style scoped></style>
